import React from 'react'
import { useState } from 'react'
import { useAuth } from '../Context/authContext'
import {FiLogIn} from 'react-icons/fi'
import {GiHamburgerMenu} from 'react-icons/gi'
import { Fade } from 'react-awesome-reveal'
import { Link, useNavigate} from 'react-router-dom'
import './Navbar.css'
import {navItems} from './NavItems'
import { signOut } from "firebase/auth"
import { auth } from '../Firebase'



const Navbar = () => {
    const [drop,setDrop] = useState(false);
    const { currentUser, setCurrentUser } = useAuth();
    const navigate = useNavigate();

  return (
  <nav className='navbar'>
    <Link to="/" className='nav-logo'><img src="/images/Aerophilia-logo.png" className='logo' ></img></Link>
    <div className='nav-menu'>
        <Fade>
    <ul className={`nav-items font-face-ic ${drop?'nav-responsive':''}`} >
        {
            navItems.map((item)=>{
                return(
                    <li key={item.id} className={`${item.cName} 
                    
                    `}>
                        <Link to={item.path} onClick={()=>{setDrop(false);
                      
                           
                        }
                            } target={item.target}>{item.title}</Link>
                        
                    </li>
                );      
            })
        }
        <li><a href='https://challengers.org.in/'>ABOUT US</a></li>
    </ul>
    </Fade>

    {currentUser? <button className='button-63 btn' onClick={ async ()=>{
        await signOut(auth).then(() => {
            navigate("/")
            console.log("Logged out");
        })
        setCurrentUser(null)}}>
            <div className=''>Logout</div>
            <div className='login-sym'><FiLogIn/></div>
            </button>
   
    :
    <Link to="/login">
        <button className='button-63 btn'>
            <div className=''>Login</div>
            <div className='login-sym'><FiLogIn/></div>
            </button></Link>
    }
    <GiHamburgerMenu className='hamburger' onClick={drop?()=>setDrop(false):()=>setDrop(true)}/>
    </div>
  </nav>
  )
}

export default Navbar